import { useEffect, useState } from 'react';

import { useLazyGetMasterDataQuery } from '../service/common';
import { VehicleType } from '../types/General';
import { MASTER_DATA } from '../utils/enums';

const useGetVehicleTypes = () => {
  const [data, setData] = useState<VehicleType[]>([]);
  const [getMasterData] = useLazyGetMasterDataQuery();
  const [load, setLoad] = useState<boolean>(false);

  const fetchData = async () => {
    setLoad(true);
    try {
      const res = await getMasterData({
        search: MASTER_DATA.VEHICLE_TYPE,
      }).unwrap();
      if (res?.statusCode === 200) {
        const { vehicleType } = res?.data || {};
        setData(vehicleType);
        setLoad(false);
      }
    } catch (error: any) {
      console.error(error);
      setLoad(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return { data, fetchData, load };
};

export default useGetVehicleTypes;
